import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useAppStore from '../../../store/app';
import SetPasswordAnd2FA from '@/components/signup/SetPasswordAnd2FA';
import ToastMessage from '@/components/toasts/ToastMessage';
import { toast } from 'react-toastify';

export default function ConfirmEmail() {
  const theme = useTheme();
  const state = useAppStore((state) => state.hero);
  const location = useLocation();
  const navigate = useNavigate();

  const lg = useMediaQuery(theme.breakpoints.up('lg'));

  const [success, setSuccess] = useState(false);
  const [showSetPassword, setShowSetPassword] = useState(true);

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  localStorage.setItem('userToken', token);

  const handleSuccess = () => {
    setShowSetPassword(false);
    setSuccess(true);
    toast.success(
      <ToastMessage title="Passwort und 2FA erfolgreich gesetzt" />,
    );
    localStorage.removeItem('userToken');
  };

  const handleFailure = (message) => {
    setShowSetPassword(false);
    setSuccess(false);
    toast.error(<ToastMessage title={message} />);
  };

  return (
    <Box
      id="hero"
      sx={{
        height: 'calc(100vh - 94px)',
        maxWidth: '1500px',
        width: '80%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '92px',
        [theme.breakpoints.down('md')]: {
          mt: '120px',
          flexDirection: 'column-reverse',
          justifyContent: 'flex-start',
          alignItems: 'center',
        },
        [theme.breakpoints.down('sm')]: {
          gap: '32px',
        },
      }}
    >
      {showSetPassword ? (
        <SetPasswordAnd2FA
          token={token}
          onSuccess={handleSuccess}
          onFailure={handleFailure}
        />
      ) : success ? (
        <>
          <Box
            sx={{
              width: '500px',
              [theme.breakpoints.down('md')]: {
                pb: '20%',
              },
              [theme.breakpoints.down('sm')]: {
                width: '100%',
                px: '24px',
              },
            }}
          >
            <Typography
              sx={{
                fontWeight: '800',
                fontSize: '48px',
                lineHeight: '1.2',
                [theme.breakpoints.down('sm')]: {
                  fontSize: '28px',
                },
              }}
            >
              Ihr Account wurde erfolgreich registriert!
            </Typography>

            <Typography
              sx={{
                mt: '22px',
                fontSize: '16px',
                [theme.breakpoints.down('sm')]: {
                  fontSize: '14px',
                },
              }}
            >
              Sie können nun fortfahren.
            </Typography>

            <Button
              color="primary"
              sx={{
                mt: '32px',
                width: '180px',
                fontSize: '16px',
                fontWeight: '700',
                border: '3px solid',
                borderRadius: '0',
                '&:hover': {
                  border: '3px solid primary.main',
                },
              }}
              variant="outlined"
              onClick={() => navigate('/organizer')}
            >
              Zum Login
            </Button>
          </Box>
          <Box
            sx={{
              flexShrink: 999,
              [theme.breakpoints.down('sm')]: {
                pt: '50px',
              },
            }}
          >
            {(state === 'graphics' || !lg) && (
              <img
                src="/static/confirmEmail.svg"
                alt="E-Mail bestätigen"
                style={{ maxWidth: '450px', width: '100%' }}
              />
            )}
          </Box>
        </>
      ) : (
        <>
          <>
            <Box
              sx={{
                width: '500px',
                [theme.breakpoints.down('md')]: {
                  pb: '20%',
                },
                [theme.breakpoints.down('sm')]: {
                  width: '100%',
                  px: '24px',
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: '800',
                  fontSize: '48px',
                  lineHeight: '1.2',
                  [theme.breakpoints.down('sm')]: {
                    fontSize: '28px',
                  },
                }}
              >
                Es ist ein Fehler beim Registrieren ihres Accounts
                aufgetreten.{' '}
              </Typography>

              <Typography
                sx={{
                  mt: '22px',
                  fontSize: '16px',
                  [theme.breakpoints.down('sm')]: {
                    fontSize: '14px',
                  },
                }}
              >
                Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '32px',
                  mt: '32px',
                }}
              >
                <Button
                  color="primary"
                  sx={{
                    width: '180px',
                    fontSize: '16px',
                    fontWeight: '700',
                    border: '3px solid',
                    borderRadius: '0',
                    '&:hover': {
                      border: '3px solid primary.main',
                    },
                  }}
                  variant="outlined"
                  onClick={() => navigate('/')}
                >
                  Zur Startseite
                </Button>

                <Button
                  color="primary"
                  sx={{
                    width: '180px',
                    fontSize: '16px',
                    fontWeight: '700',
                    border: '3px solid',
                    borderRadius: '0',
                    '&:hover': {
                      border: '3px solid primary.main',
                    },
                  }}
                  variant="outlined"
                  onClick={() => setShowSetPassword(true)}
                >
                  Erneut versuchen
                </Button>
              </Box>
            </Box>
            <Box
              sx={{
                flexShrink: 999,
                [theme.breakpoints.down('sm')]: {
                  pt: '50px',
                },
              }}
            >
              {(state === 'graphics' || !lg) && (
                <img
                  src="/static/confirmEmailError.svg"
                  alt="E-Mail bestätigen"
                  style={{ maxWidth: '450px', width: '100%' }}
                />
              )}
            </Box>
          </>
        </>
      )}
    </Box>
  );
}
